"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AesGcm = void 0;
const buffer_1 = require("buffer/");
const ALGO = "AES-GCM";
const IV_LEN_BYTES = 12;
const TAG_LEN_BITS = 128;
class AesGcm {
    constructor(key, cryptoLib) {
        this.key = key;
        this.cryptoLib = cryptoLib;
    }
    async encrypt(buf) {
        const windowKey = await this.cryptoLib.subtle.importKey("raw", this.key, ALGO, false, ["encrypt", "decrypt"]);
        const iv = this.cryptoLib.getRandomValues(new Uint8Array(IV_LEN_BYTES));
        const cipher = await this.cryptoLib.subtle.encrypt({ name: ALGO, iv: iv, tagLength: TAG_LEN_BITS }, windowKey, buf);
        const output = buffer_1.Buffer.concat([buffer_1.Buffer.from(iv), buffer_1.Buffer.from(cipher)]);
        return output;
    }
    async decrypt(data) {
        const iv = data.subarray(0, IV_LEN_BYTES);
        const enc = data.subarray(IV_LEN_BYTES);
        const windowKey = await this.cryptoLib.subtle.importKey("raw", this.key, ALGO, false, ["encrypt", "decrypt"]);
        const decipher = await this.cryptoLib.subtle.decrypt({ name: ALGO, iv, tagLength: TAG_LEN_BITS }, windowKey, enc);
        return decipher;
    }
}
exports.AesGcm = AesGcm;
